import { Option, Schema } from 'effect';

/**
 * Filesystem-safe identifier shared by self-host routes and persistence.
 *
 * Leading dots and path separators are intentionally excluded so a decoded
 * route parameter can never become a relative path segment.
 */
export const SelfHostResourceIdSchema = Schema.String.check(
  Schema.isMinLength(1),
  Schema.isMaxLength(255),
  Schema.isPattern(/^[A-Za-z0-9_][A-Za-z0-9._-]*$/),
).annotate({
  identifier: 'SelfHostResourceId',
  description: 'A stable filesystem-safe self-host resource identifier.',
});

const decodeSelfHostResourceId = Schema.decodeUnknownOption(SelfHostResourceIdSchema);

export function isSelfHostResourceId(value: unknown): value is string {
  return Option.isSome(decodeSelfHostResourceId(value));
}
